module.exports = __webpack_public_path__ + "img/appswitcher.85db49c0.png";